exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\r\n  padding: 2em\r\n}\r\nh3 {\r\n  margin:0\r\n}\r\n.container {\r\n  padding-bottom:0\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/loanprograms.component.css
// module id = ../../../../../src/app/loanprograms/loanprograms.component.css
// module chunks = main